import { Environment } from 'types';
import { authHost } from './apiUser';
import { fallbackErrorMessage } from './constants';

interface PasswordChallenge {
  email: string;
  verifier: string;
}

export function setPasswordChallenge(verifier: string, email: string): void {
  const state = { email, verifier };
  window.localStorage.setItem(challengeKey, JSON.stringify(state));
}

export function setEmailChallenge(email: string): void {
  const state = { email, challenge: '' };
  window.localStorage.setItem(challengeKey, JSON.stringify(state));
}

const challengeKey = '__pwd_challenge__';

export function clearPasswordChallenge(): void {
  window.localStorage.removeItem(challengeKey);
}

export function getPasswordChallenge(): PasswordChallenge | undefined {
  const challenge = window.localStorage.getItem(challengeKey);
  if (challenge) {
    return JSON.parse(challenge);
  }
}

export interface ResetArgs {
  password: string;
  email: string;
  verifier: string;
}

export async function reset(
  { email, password, verifier }: ResetArgs,
  environment: Environment
) {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('password', password);
  formData.append('code_verifier', verifier);

  const response = await fetch(`${authHost(environment)}/reset`, {
    method: 'POST',
    body: formData,
  });
  const data = await response.json();
  if (response.ok) {
    return data;
  } else {
    return Promise.reject(fallbackErrorMessage);
  }
}

export async function forgot(email: string, environment: Environment) {
  const formData = new FormData();
  formData.append('email', email);
  const response = await fetch(`${authHost(environment)}/forgot`, {
    method: 'POST',
    body: formData,
  });
  const data = await response.json();
  if (response.ok) {
    return data;
  } else {
    return Promise.reject(fallbackErrorMessage);
  }
}
